<ws-modal-wrapper headerLabel="Parcel Analysis"
                  [hideFooter]="true"
                  [excludeModalStyling]="true"
                  (cancel)="close()">
    <div class="overflow-y-auto" style="height: 340px;">
        <activity-panel [siteId]="params.siteId"
                        [parcelId]="params.parcelId"
                        [parcelYears]="params.years">
        </activity-panel>
    </div>
</ws-modal-wrapper>
